import React from 'react';
import CursorTrail from './CursorTrail';

/**
 * Le fond de l'application.
 *
 * ⚠️ Extrait d'`App.tsx` pour une raison precise : il est rendu **des deux cotes de la frontiere
 * d'authentification** — sur la landing d'un visiteur non connecte comme dans l'app d'un membre.
 * Le laisser dans le morceau authentifie l'aurait rendu indisponible a la landing ; le dupliquer
 * aurait fait deriver les deux copies.
 *
 * ⚠️ LA GRILLE DE LIGNES A ETE RETIREE (03/09). Trois traits verticaux et deux horizontaux se
 * croisaient sur toute la page : a 10 % d'opacite ils ne se lisaient pas comme un motif, mais ils
 * decoupaient l'ecran en rectangles et posaient des traits qui passaient DERRIERE les cartes.
 * Un fond doit se voir comme une profondeur, pas comme une geometrie qui entre en concurrence
 * avec les bordures de l'interface. Les halos et les particules restent : eux n'ont pas d'aretes.
 *
 * ⚠️ LES PARTICULES AUSSI (03/09). Quinze points animes en boucle infinie sur toutes les pages,
 * pour un effet que personne ne regardait. Un fond qui bouge en permanence coute du travail au
 * navigateur a chaque image, sur chaque appareil, indefiniment.
 *
 * `React.memo` remplace le `useMemo` qu'il etait : meme effet — il ne se re-rend pas — sans
 * dependre du composant qui l'accueille.
 */
const Background: React.FC = () => (
  <>
    <CursorTrail />
    <div className="absolute inset-0 z-0">
      <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-br from-[#0a1520] via-[#0f2b3d] to-[#0a1a2f] opacity-90" />
      <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-blue-400/10 rounded-full blur-3xl" />
      <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-sky-400/8 rounded-full blur-3xl" />
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-blue-500/8 rounded-full blur-3xl" />
    </div>
  </>);

export default React.memo(Background);
